@if (overlayActive) {
  <div
    class="overlay"
    [ngStyle]="{ height: 'calc(' + elementHeight + 'px - var(--bdeo-spacing-04))', opacity: 0.24 }"
    (click)="toggle()"
  ></div>
}
<div class="accordion">
  <div #content class="accordion__content" [ngStyle]="{ 'max-height': isOpen ? contentHeight + 'px' : '0px' }">
    <div class="accordion__content-header">
      <ng-content select="[content-header]"></ng-content>
      <bdeo-button data-test-id="open-accordion" bigIcon size="small" icon="action-close" (click)="toggle()"></bdeo-button>
    </div>
    <div class="accordion__content-body">
      <ng-content></ng-content>
    </div>
  </div>
  @if (hasHeader) {
    <div class="accordion__header">
      <ng-content select="[header]"></ng-content>
      <bdeo-button bigIcon size="medium" icon="arrow-angle-up" [ngClass]="{ open: isOpen }" (click)="toggle()"></bdeo-button>
    </div>
  }
</div>
